__turbopack_context__.v({
  "productPannel": "product-price-block-module-scss-module__V0sMIq__productPannel",
  "productPriceWidget": "product-price-block-module-scss-module__V0sMIq__productPriceWidget",
});
